import React from 'react';
import Divider from './divider';

const LocalesSelectorWrapper = ({ children }) => (
  <div className="ws-ui-editor-header__locales-selector-wrapper">
    <div className="ws-ui-editor-header__locales-selector-btn">{children}</div>
    <Divider />
  </div>
);

export default LocalesSelectorWrapper;
